(() => {
  const d = document, $ = (s, r = d) => r.querySelector(s), $$ = (s, r = d) => [...r.querySelectorAll(s)];

  /* scroll reveal: one observer, class toggle only (opacity/transform in CSS) */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  const watch = () => $$('.reveal:not(.is-in)').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  watch();
  d.addEventListener('shopify:section:load', watch);

  /* hero tilt: pointer sets CSS vars (rAF-throttled); CSS does the easing */
  const vis = $('.hero__vis');
  if (vis && matchMedia('(hover:hover) and (prefers-reduced-motion:no-preference)').matches) {
    const hero = vis.closest('.hero'); let raf = 0;
    hero.addEventListener('pointermove', e => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        vis.style.setProperty('--rx', (y * -7).toFixed(2) + 'deg'); vis.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg'); vis.style.setProperty('--tx', (x * -26).toFixed(1) + 'px');
        raf = 0;
      });
    }, { passive: true });
    hero.addEventListener('pointerleave', () => ['--rx', '--ry', '--tx'].forEach(v => vis.style.removeProperty(v)));
  }

  /* product page: variant picking + ajax add to cart */
  const pj = $('[data-product-json]'), f = $('[data-product-form]');
  if (pj && f) {
    const p = JSON.parse(pj.textContent), idInput = $('[name=id]', f), btn = $('[data-add]', f), price = $('[data-price]');
    const money = c => new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100);
    const radios = $$('input[type=radio]', f);
    if (radios.length) f.addEventListener('change', () => {
      const picked = radios.filter(r => r.checked).map(r => r.value);
      const v = p.variants.find(v => v.options.every((o, i) => o === picked[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id; price.textContent = money(v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out';
    });
    f.addEventListener('submit', async e => {
      e.preventDefault();
      const label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding';
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error();
        const c = await (await fetch(root + 'cart.js')).json();
        $$('[data-cart-count]').forEach(n => { n.textContent = c.item_count; });
        btn.textContent = 'Added';
      } catch (_) { btn.textContent = 'Try again'; }
      setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1400);
    });
  }
})();
